import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

const announcementService = {
  list: async ({ filter, search } = {}) => {
    const routePath = getManagerRoutePath();
    const params = {};
    if (filter) params.filter = filter;
    if (search) params.search = search;
    const response = await axiosInstance.get(`/${routePath}/announcements`, { params });
    return response.data;
  },

  options: async () => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.get(`/${routePath}/announcements/options`);
    return response.data;
  },

  create: async (payload) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.post(`/${routePath}/announcements`, payload);
    return response.data;
  },

  togglePin: async (id) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.patch(`/${routePath}/announcements/${id}/pin`);
    return response.data;
  },

  toggleArchive: async (id) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.patch(`/${routePath}/announcements/${id}/archive`);
    return response.data;
  },

  remove: async (id) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.delete(`/${routePath}/announcements/${id}`);
    return response.data;
  },
};

export default announcementService;
